import styled from "styled-components";
import { useTranslation } from "react-i18next";
import SectionHeaderRow from "../shared/SectionHeaderRow";
import StoreCard from "../cards/StoreCard";
import { cPath } from "../../constants";

const Section = styled.section`
  padding: 1.5rem 0;
`;

const ContentWrap = styled.div`
  width: 90%;
  margin: 0 auto;
`;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 1rem;
`;

export default function HomePopularStores({ filteredStores }) {
  const { t } = useTranslation();
  const list = filteredStores.slice(0, 12);

  return (
    <Section>
      <ContentWrap>
        <SectionHeaderRow
          title={t("home.popularStores.title")}
          to={cPath("stores")}
          linkLabel={t("home.popularStores.viewAll")}
          marginBottom="1rem"
        />
        <Grid>
          {list.map((store) => (
            <StoreCard key={store.id} store={store} />
          ))}
        </Grid>
      </ContentWrap>
    </Section>
  );
}
